import React, { useContext, useState } from "react";
import { Card, CardHeader, Col, Row } from "reactstrap";
import ViewOfferSubTabs from "./ViewOfferSubTabs";
import { VIEW_OFFER_TABS } from "./constants/initialValues";
import { ViewOfferContext } from "./context";
import ViewOfferGrantsOneTime from "./ViewOfferGrantsOneTime";
import ViewOfferGrantsRecurring from "./ViewOfferGrantsRecurring";

const ViewOfferGrants = ({ activeTab, setActiveTab }) => {
  const { values } = useContext(ViewOfferContext);

  return (
    <Row className="mb-4">
      <Col lg={12}>
        <ViewOfferSubTabs activeTab={activeTab} setActiveTab={setActiveTab} />
        {activeTab === VIEW_OFFER_TABS.RECURRING ? (
          <ViewOfferGrantsRecurring
            grantsRecurringList={values?.recurringGrants || []}
          />
        ) : (
          <ViewOfferGrantsOneTime grantsOneTimeList={values?.grants || []} />
        )}
      </Col>
    </Row>
  );
};

export default ViewOfferGrants;
